/**
 * Sku only provide zh-CN lang by default
 */
export default {
    'zh-CN': {
        vanSku: {
            select: '选择',
            selected: '已选',
            selectSku: '请先选择商品规格',
            soldout: '库存不足',
            originPrice: '原价',
            minusTip: '至少选择一件',
            unavailable: '商品已经无法购买啦',
            stock: '剩余',
            stockUnit: '件',
            quotaLimit: function quotaLimit (quota) {
                return '\u6BCF\u4EBA\u9650\u8D2D' + quota + '\u4EF6'
            },
            quotaCount: function quotaCount (count) {
                return '\u4F60\u5DF2\u8D2D\u4E70' + count + '\u4EF6'
            }
        },
        vanSkuActions: {
            buy: '立即购买',
            addCart: '加入购物车'
        },
        vanSkuImgUploader: {
            oversize: function oversize (maxSize) {
                return '\u6700\u5927\u53EF\u4E0A\u4F20\u56FE\u7247\u4E3A' + maxSize + 'MB\uFF0C\u8BF7\u5C1D\u8BD5\u538B\u7F29\u56FE\u7247\u5C3A\u5BF8'
            },
            fail: '上传失败<br />重新上传'
        },
        vanSkuStepper: {
            num: '购买数量'
        },
        vanSkuMessages: {
            fill: '请填写',
            upload: '请上传',
            imageLabel: '仅限一张',
            invalid: {
                tel: '请填写正确的数字格式留言',
                mobile: '手机号长度为6-20位数字',
                email: '请填写正确的邮箱',
                id_no: '请填写正确的身份证号码'
            },
            placeholder: {
                id_no: '输入身份证号码',
                text: '输入文本',
                tel: '输入数字',
                email: '输入邮箱',
                date: '点击选择日期',
                time: '点击选择时间',
                textarea: '点击填写段落文本',
                mobile: '输入手机号码'
            }
        }
    }
}
